import { AlertTriangle } from 'lucide-react';

import type { AgentChatActivityEvent } from '@/services/agents/chat-stream';

const MODEL_FALLBACK_PATTERN = /\bmodel\b.+\bunavailable\b/i;

export function findModelFallbackNotice(
  events: AgentChatActivityEvent[],
): string | null {
  for (let i = events.length - 1; i >= 0; i--) {
    const event = events[i];
    if (
      event.type === 'status' &&
      event.text &&
      MODEL_FALLBACK_PATTERN.test(event.text)
    ) {
      return event.text;
    }
  }
  return null;
}

export function ModelFallbackNotice({
  events,
}: {
  events: AgentChatActivityEvent[];
}) {
  const notice = findModelFallbackNotice(events);
  if (!notice) return null;
  return (
    <div
      role='status'
      className='flex items-center gap-1.5 rounded-md border border-amber-500/40 bg-amber-500/10 px-2 py-1 text-xs text-amber-600 dark:text-amber-400'
    >
      <AlertTriangle className='size-3.5 shrink-0' />
      <span className='min-w-0 break-words'>{notice}</span>
    </div>
  );
}
